import { render, staticRenderFns } from "./AdItemCreateForm.vue?vue&type=template&id=12bde44c&"
import script from "./AdItemCreateForm.vue?vue&type=script&lang=ts&"
export * from "./AdItemCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports